export default __webpack_public_path__ + "static/media/tractor.icon.fffaf79a.svg";